// _TODO: i18n
import { FunctionComponent } from 'react';
import * as vp from 'vopay';
import { useClientData } from '@/providers/ClientData.provider';

const { Box, Radio, Card } = vp;

type SettingsTabProps = {
  lang: string;
  receiveOnly?: boolean;
};

const SettingsTab: FunctionComponent<SettingsTabProps> = ({ lang, receiveOnly }) => {
  const { response } = useClientData();

  return (
    <Box flx="col" gapSize="24px">
      <Card title="Default Language">
        <Box jc="sb">
          <Box>The primary language used to communicate with this client account.</Box>
          <Box jc="fe" pe="smd">
            <Radio
              name="client-account-language"
              variant="inline"
              value={lang || 'en'}
              options={{
                en: 'English',
                fr: 'Francais',
              }}
              readOnly
              onChange={() => {}}
            />
          </Box>
        </Box>
      </Card>

      {response.clientAccountsEnabled && (
        <Card title="Transaction Permissions">
          <Box jc="sb" ai="fe">
            <Box lineHeight="150%" maxwidth="50%">
              Send & Receive funds client accounts allow outbound and inbound transactions. Receive-Only Client Accounts
              are limited to inbound transactions.
            </Box>
            <Box jc="fe" pe="smd">
              <Radio
                name="client-account-type"
                variant="inline"
                value={receiveOnly ? 'receiveOnly' : 'sendReceive'}
                options={{
                  sendReceive: 'Send & Receive Funds',
                  receiveOnly: 'Receive-Only',
                }}
                noOrdering
                readOnly
                onChange={() => {}}
              />
            </Box>
          </Box>
        </Card>
      )}
    </Box>
  );
};
export default SettingsTab;
